import { ACCOUNTING_OPENING_CUTOVER_APPROVE, ACCOUNTING_OPENING_CUTOVER_GET, ACCOUNTING_OPENING_CUTOVER_PREVIEW, CORPORATE_ACTION_CREATE, CORPORATE_ACTION_LIST, IMPORT_UPLOAD, INSTRUMENT_LIST, INSTRUMENT_BULK_UPSERT, MARKET_DATA_LIST, MARKET_DATA_BULK_UPSERT, RECONCILIATION_RUN_CREATE, TRANSACTION_CREATE, TRANSACTION_LIST, TAX_RULE_CREATE_VERSION, TAX_RULE_LIST, } from './operation-ids.js';
import { PORTFOLIO_CUSTODY_EVIDENCE_LIST } from './portfolio-custody.operations.js';
import { FEE_RULE_CREATE_VERSION, FEE_RULE_LIST } from './fee-rule.operations.js';
export const IMPORT_TYPE_IDS = [
    'TRANSACTION',
    'INSTRUMENT',
    'MARKET_DATA',
    'CORPORATE_ACTION',
    'CUSTODY_POSITION',
    'OPENING_CUTOVER',
    'TAX_RULE',
    'FEE_RULE',
];
/**
 * Import types accepted by the persisted ImportJob contract.
 *
 * This is intentionally separate from the lifecycle operations: a caller that
 * may create an import job must also hold the authority for the data type the
 * job will change. Keeping that relationship in contracts prevents the API,
 * UI, and operation bundles from growing divergent per-type checks.
 */
export const IMPORT_TYPE_AUTHORIZATION = Object.freeze({
    TRANSACTION: Object.freeze({
        requiredOperationIds: [TRANSACTION_CREATE],
        requiredReadOperationIds: [TRANSACTION_LIST],
        requiresReferenceDataAuthority: false,
    }),
    INSTRUMENT: Object.freeze({
        requiredOperationIds: [INSTRUMENT_BULK_UPSERT],
        requiredReadOperationIds: [INSTRUMENT_LIST],
        requiresReferenceDataAuthority: true,
    }),
    MARKET_DATA: Object.freeze({
        requiredOperationIds: [MARKET_DATA_BULK_UPSERT],
        requiredReadOperationIds: [MARKET_DATA_LIST],
        requiresReferenceDataAuthority: true,
    }),
    CORPORATE_ACTION: Object.freeze({
        requiredOperationIds: [CORPORATE_ACTION_CREATE],
        requiredReadOperationIds: [CORPORATE_ACTION_LIST],
        requiresReferenceDataAuthority: false,
    }),
    CUSTODY_POSITION: Object.freeze({
        requiredOperationIds: [RECONCILIATION_RUN_CREATE],
        requiredReadOperationIds: [PORTFOLIO_CUSTODY_EVIDENCE_LIST],
        requiresReferenceDataAuthority: false,
    }),
    OPENING_CUTOVER: Object.freeze({
        requiredOperationIds: [ACCOUNTING_OPENING_CUTOVER_PREVIEW, ACCOUNTING_OPENING_CUTOVER_APPROVE],
        requiredReadOperationIds: [ACCOUNTING_OPENING_CUTOVER_GET],
        requiresReferenceDataAuthority: false,
    }),
    TAX_RULE: Object.freeze({
        requiredOperationIds: [TAX_RULE_CREATE_VERSION],
        requiredReadOperationIds: [TAX_RULE_LIST],
        requiresReferenceDataAuthority: false,
    }),
    FEE_RULE: Object.freeze({
        requiredOperationIds: [FEE_RULE_CREATE_VERSION],
        requiredReadOperationIds: [FEE_RULE_LIST],
        requiresReferenceDataAuthority: false,
    }),
});
export function getImportTypeAuthorization(importType) {
    return IMPORT_TYPE_AUTHORIZATION[importType.trim().toUpperCase()];
}
/** The upload operation is included here only as a registry completeness aid. */
export const IMPORT_TYPE_LIFECYCLE_OPERATION_ID = IMPORT_UPLOAD;
